module.exports = __webpack_public_path__ + "static/media/plan10.db2f7c50.pdf";